module.exports = __webpack_public_path__ + "assets/img/swiss_meringue.6cda2295.png";